const social = () => {
	const el = document.querySelector('.c-editorial__social');
	const elActiveClass = 'c-editorial__social--active';
	const toggleEl = document.querySelector('.c-editorial__social--toggle');
	const toggleLabel = toggleEl ? toggleEl.querySelector('.c-editorial__social--toggle-label') : undefined;

	const handleToggleClick = (close) => {
		const navInner = el.querySelector('.c-editorial__social--menu');

		// toggle the navigation's active class
		el.classList.toggle(elActiveClass);

		const isActive = el.classList.contains(elActiveClass);

		// Also, update screen reader attribute if applicable
		navInner.setAttribute('aria-hidden', !isActive);

		if (close || !isActive) {
			// If it's not active, reset hidden attribute
			navInner.setAttribute('hidden', true);

			if (toggleLabel) {
				toggleLabel.innerText = toggleEl.getAttribute('data-label-default');
			}
		} else {
			// else remove the hidden attribute
			navInner.removeAttribute('hidden');

			if (toggleLabel) {
				toggleLabel.innerText = toggleEl.getAttribute('data-label-close');
			}
		}

		// update screen reader arribute
		toggleEl.setAttribute('aria-expanded', isActive);
	};

	if (el && toggleEl) {
		// When user clicks toggle button
		toggleEl.addEventListener('click', () => handleToggleClick());

		// When user clicks ESC
		// TODO: this needs improving
		document.body.addEventListener('keydown', (e) => {
			// console.log(e);
			if (e.keyCode === 27 && el.classList.contains(elActiveClass)) {
				handleToggleClick(true);
			}
		});
	}
};

export default social;
